interface ViewItem {
	url:string;
	index:number;
}

/**
* @ngdoc service
* @name  sharebase-app.sbaViewItemIndexDataStore
* 
* @description 
* A datastore used to interact with previous page item indexes.  Allowing 
* reload of specific pages to pick up where the user left off.
* 
**/
export function ViewItemIndexDataStoreFactory() {
	let stack:ViewItem[] = [];

	return {
		/**
		* @ngdoc method
		* @name sbaViewItemIndexDataStore#add
		* @methodOf sharebase-app.sbaViewItemIndexDataStore
		* @kind function
		*
		* @description
		* Adds or updates a urls last know item index
		* 
		* @param {object} url A url of the index to store
		* 
		* @param {object} index An integer value of the item index
		*/
		add,
		/**
		* @ngdoc method
		* @name sbaViewItemIndexDataStore#clearAll
		* @methodOf sharebase-app.sbaViewItemIndexDataStore
		* @kind function
		*
		* @description
		* Removes all save view item indexes
		*/
		clearAll,

		/**
		* @ngdoc method
		* @name sbaViewItemIndexDataStore#remove
		* @methodOf sharebase-app.sbaViewItemIndexDataStore
		* @kind function
		*
		* @description
		* Removes a urls last know item index
		* 
		* @param {object} url A url of the index to remove
		*/
		remove,

		/**
		* @ngdoc property
		* @name sbaViewItemIndexDataStore#indexes
		* @propertyOf sharebase-app.sbaViewItemIndexDataStore
		* @kind property
		*
		* @description
		* An array of stored view item indexes
		*
		* @returns {object} An array of view item indexes
		*/
		get indexes() { return stack; },

		/**
		* @ngdoc property
		* @name sbaViewItemIndexDataStore#urlIndex
		* @propertyOf sharebase-app.sbaViewItemIndexDataStore
		* @kind property
		*
		* @description
		* An index of the item to display on top of screen
		*
		* @returns {object} An integer of the index
		*/
		urlIndex: getIndexForUrl
	};

	function add(url, index) {
		remove(url);
		if (!angular.isNumber(index) || index === 0) { return; }
		stack.push({ 
			url, 
			index 
		});
	}
	
	function clearAll(){
		stack = [];
	}

	function remove(url:string) {
		stack = stack.filter(view => view.url !== url);
	}

	function getIndexForUrl(url) {
		let itemsFound = stack.filter(view => view.url === url);
		return itemsFound.length === 1 ? itemsFound[0].index : 0;
	}
}



// WEBPACK FOOTER //
// ./src/sharebase-app/dataStores/viewItemIndexDataStore.ts